// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
.ai-panel {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 400px;
  max-width: calc(100vw - 56px);
  height: calc(100vh - 62px);
  background: #ecf3f7;
  color: var(--cs-secondary-color);
  border-left: 1px solid rgba(var(--cs-secondary-color), 0.3);
  display: flex;
  flex-direction: column;
  z-index: 2000;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
}
.ai-panel .panel-collapased {
  height: 0;
}

/* minimised state: show header only */
.ai-panel.ai-minimised {
  height: auto;
  max-height: none;
  /* slightly reduce header padding when minimised */
}
.ai-panel.ai-minimised .ai-body,
.ai-panel.ai-minimised .ai-footer {
  display: none;
}
.ai-panel.ai-minimised .ai-header {
  border-bottom: none;
}
.ai-panel.ai-minimised .ai-header {
  padding: 0.5rem 0.75rem;
}

.ai-table-scroll {
  overflow-x: auto;
  width: 100%;
}

.ai-table-container {
  margin-top: 10px;
  overflow-x: auto;
}

.ai-table {
  min-width: 700px;
  border-collapse: collapse;
}

.ai-table th,
.ai-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  text-align: left;
  white-space: nowrap;
}

.ai-table th {
  background: #ecf3f7;
  cursor: pointer;
  font-weight: 500;
}

.ai-pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
}

.ai-page-btn {
  padding: 4px 10px;
  cursor: pointer;
  border: 1px solid #6495ed;
  color: cornflowerblue;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  display: flex;
  align-items: center;
}

.ai-download-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.ai-download-btn {
  padding: 6px 10px;
  cursor: pointer;
  border: none;
  background: #347800;
  color: #fff;
  border-radius: 3px;
}

.ai-result-summary {
  font-size: 13px;
  color: #777;
  margin-bottom: 6px;
}

.ai-header {
  min-height: 52px;
  padding: 0.8rem 1rem;
  background: var(--cs-primary-color);
  color: #fff;
  border-bottom: 1px solid rgba(var(--cs-secondary-color), 0.25);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ai-header .ai-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: Roboto-Medium;
  font-size: 14px;
}
.ai-header .ai-title cs-icon {
  width: 16px;
  height: 16px;
  color: #fff;
}
.ai-header .ai-close-btn {
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: transparent;
  color: #fff;
  width: 28px;
  height: 28px;
  line-height: 1;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
}
.ai-header .ai-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.ai-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem 0.9rem;
  background: rgba(var(--cs-secondary-color), 0.03);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.ai-body .ai-empty-state {
  background: #fff;
  border: 1px solid rgba(var(--cs-secondary-color), 0.18);
  border-radius: 6px;
  padding: 0.8rem;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
}
.ai-body .ai-empty-state .empty-title {
  font-family: Roboto-Medium;
  font-size: 14px;
  margin-bottom: 0.3rem;
}
.ai-body .ai-empty-state .empty-subtitle {
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.85;
}
.ai-body .suggestions {
  border: 1px solid rgba(var(--cs-secondary-color), 0.22);
  background: #fff;
  border-radius: 6px;
  padding: 0.75rem;
}
.ai-body .suggestions .suggestions-title {
  margin: 0 0 0.5rem;
  font-family: Roboto-Medium;
  font-size: 13px;
}
.ai-body .suggestions .suggestion {
  width: 100%;
  text-align: left;
  font-family: Roboto-Regular;
  font-size: 12px;
  padding: 0.45rem 0.5rem;
  border: 1px solid rgba(var(--cs-secondary-color), 0.3);
  border-radius: 4px;
  background: rgba(var(--cs-secondary-color), 0.03);
  color: var(--cs-secondary-color);
  cursor: text;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
}
.ai-body .suggestions .suggestion:hover {
  border-color: rgba(var(--cs-primary-color), 0.65);
  background: rgba(var(--cs-primary-color), 0.08);
}
.ai-body .suggestions .suggestion + .suggestion {
  margin-top: 0.45rem;
}
.ai-body .chat-msg {
  max-width: 100%;
  padding: 0.6rem 0.7rem;
  font-family: Roboto-Regular;
  font-size: 12px;
  line-height: 1.4;
  border-radius: 8px;
  border: 1px solid rgba(var(--cs-secondary-color), 0.18);
  word-break: break-word;
}
.ai-body .chat-msg.ai-msg .msg-text {
  text-align: center;
  color: #00a543;
  font-size: 14px;
}
.ai-body .user-msg {
  margin-left: auto;
  color: #fff;
  background: var(--cs-primary-color);
  border-color: var(--cs-primary-color);
  border-bottom-right-radius: 2px;
}
.ai-body .ai-msg {
  margin-right: auto;
  background: #fff;
  border-bottom-left-radius: 2px;
}
.ai-body .ai-response-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}
.ai-body .ai-response-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid rgba(var(--cs-secondary-color), 0.22);
  border-radius: 14px;
  background: #fff;
  color: rgba(var(--cs-secondary-color), 0.8);
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.15s ease;
}
.ai-body .ai-response-action .action-icon {
  font-size: 12px;
  line-height: 1;
}
.ai-body .ai-response-action .action-text {
  font-family: Roboto-Regular;
}
.ai-body .ai-response-action:hover:not(:disabled) {
  border-color: rgba(var(--cs-primary-color), 0.5);
  color: var(--cs-primary-color);
  background: rgba(var(--cs-primary-color), 0.05);
}
.ai-body .ai-response-action.active {
  border-color: rgba(var(--cs-primary-color), 0.5);
  color: var(--cs-primary-color);
  background: rgba(var(--cs-primary-color), 0.08);
  font-family: Roboto-Medium;
  box-shadow: 0 0 0 1px rgba(var(--cs-primary-color), 0.15);
}
.ai-body .ai-response-action.good-active {
  border-color: #22a447;
  color: #1b8c3c;
  background: rgba(34, 164, 71, 0.1);
}
.ai-body .ai-response-action.bad-active {
  border-color: #d64545;
  color: #c93636;
  background: rgba(214, 69, 69, 0.1);
}
.ai-body .ai-response-action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.ai-body .loading-msg {
  opacity: 0.8;
  font-style: italic;
}

.ai-footer {
  padding: 0.75rem;
  border-top: 1px solid rgba(var(--cs-secondary-color), 0.2);
  background: #fff;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.ai-footer .ai-query-input {
  flex: 1;
  min-width: 0;
  height: 36px;
  border: 1px solid rgba(var(--cs-secondary-color), 0.35);
  border-radius: 4px;
  padding: 0 0.7rem;
  background-color: #fff;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  box-shadow: inset 0 0 0 1px rgba(var(--cs-secondary-color), 0.06);
  font-family: Roboto-Regular;
  font-size: 12px;
  color: var(--cs-secondary-color);
}
.ai-footer .ai-query-input::placeholder {
  color: rgba(var(--cs-secondary-color), 0.6);
}
.ai-footer .ai-query-input:focus {
  outline: none;
  border-color: var(--cs-primary-color);
  box-shadow: 0 0 0 2px rgba(var(--cs-primary-color), 0.16);
}
.ai-footer .ai-send-btn {
  height: 34px;
  min-width: 68px;
  border: 1px solid var(--cs-primary-color);
  background: var(--cs-primary-color);
  color: #fff;
  font-family: Roboto-Medium;
  font-size: 12px;
  padding: 0 0.75rem;
  cursor: pointer;
  border-radius: 4px;
}
.ai-footer .ai-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
